import { mountMahjong } from '../render/three/game-app.js';
import { makeTurtleSpec } from '../variants/mahjong-solitaire/spec.js';

mountMahjong(makeTurtleSpec()).catch((err) => {
  console.error('failed to mount mahjong solitaire', err);
});
